module.exports = function ($) {
  'use strict';

  // Disabled buttons are always disabled
  $(document).on('click', 'a.disabled, .btn.disabled', function () {
    return false;
  });
};
